import {Injectable} from '@angular/core';
import * as RolesActions from './roles.actions';
import {map, mergeMap} from 'rxjs/operators';
import {RolesPartialState} from './roles.reducer';
import {Actions, createEffect} from '@ngrx/effects';
import {DataPersistence, withCorrelationIdOf} from '@kion/ngrx-helper';
import {Role} from '@kion/data-models';
import {RoleConnectors} from "./role.connectors";

@Injectable()
export class RolesEffects {
  loadByUserId$ = createEffect(() =>
    this.dataPersistence.fetch(
      RolesActions.loadByUserId,
      {
        run: (
          action: ReturnType<typeof RolesActions.loadByUserId>
        ) => {
          if (action.currentUser) {
            return this.backend.getRolesForCurrentUser(action.userId).pipe(
              mergeMap(
                (response: Role[]) => [
                  withCorrelationIdOf(
                    action,
                    RolesActions.loadByUserIdSuccess({roles: response})
                  ),
                  withCorrelationIdOf(
                    action,
                    RolesActions.removeUnusedRolesFromUser({roles: response})
                  ),
                ]
              )
            )
          }
          return this.backend.getRolesByUser(action.userId).pipe(
            map(
              (response: Role[]) => withCorrelationIdOf(
                action,
                RolesActions.loadByUserIdSuccess({roles: response})
              )
            )
          )
        },
        onError: (
          action: ReturnType<typeof RolesActions.loadByUserId>,
          error
        ) => {
          console.error("Error", error);
          return withCorrelationIdOf(
            action,
            RolesActions.loadByUserIdError({error: error})
          );
        }
      }
    )
  );
  setRoles$ = createEffect(() =>
    this.dataPersistence.fetch(
      RolesActions.setRoles,
      {
        run: (
          action: ReturnType<typeof RolesActions.setRoles>
        ) => {
          return this.backend.changeRoles(action.userId, action.roles, true).pipe(
            map(
              (response: Role[]) => withCorrelationIdOf(
                action,
                RolesActions.setRolesSuccess({roles: response})
              )
            )
          )
        },
        onError: (
          action: ReturnType<typeof RolesActions.setRoles>,
          error
        ) => {
          console.error("Error", error);
          return withCorrelationIdOf(
            action,
            RolesActions.setRolesError({error: error})
          );
        }
      }
    )
  );
  revokeRoles$ = createEffect(() =>
    this.dataPersistence.fetch(
      RolesActions.revokeRoles,
      {
        run: (
          action: ReturnType<typeof RolesActions.revokeRoles>
        ) => {
          return this.backend.changeRoles(action.userId, action.roles, false).pipe(
            map(
              (response: Role[]) => withCorrelationIdOf(
                action,
                RolesActions.revokeRolesSuccess({roles: action.roles})
              )
            )
          )
        },
        onError: (
          action: ReturnType<typeof RolesActions.revokeRoles>,
          error
        ) => {
          console.error("Error", error);
          return withCorrelationIdOf(
            action,
            RolesActions.revokeRolesError({error: error})
          );
        }
      }
    )
  );

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<RolesPartialState>,
    private backend: RoleConnectors
  ) {
  }
}

